import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable'
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from '@mui/material';
// import BannerinputGetModal from '../../../CommonModal/BannerModal/BannerinputGetModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import '../../../../Components/ModalCss/BannerinputGetModal.css';
// import LandingPage from '../../Preview/LandingPage';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import BannerinputGetModal from '../Modal/Banner/BannerinputGetModal';
import ContactUsMainPage from '../ContactUsPreview/Banner/ContactUsMainPage';
import ContactUsModal from '../Modal/ContactUsModal/ContactUsModal';
import ContactUsection from '../ContactUsPreview/Contact/ContactUsection';
// import ReferralsMainPage from '../ReferralsContentPreview/Banner/ReferralsMainPage';

const ContactUsSection = () => {

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin" || role === "management"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Title', 'Sub Text', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "status"]
        : ['S.No', 'Title', 'Sub Text', 'status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getContactUsSectionById } = useSelector(state => state?.getContactUsSectionById);
    const { addContactUsSection } = useSelector(state => state?.addContactUsSection);

    const { updateContactUsSection } = useSelector(
        (state) => state?.updateContactUsSection
    );

    const { deleteContactUsSection } = useSelector(
        (state) => state?.deleteContactUsSection
    );




    const { getAllContactUsSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllContactUsSectionsWithCreatorBySectionName
    );

    const { getAllContactUsSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllContactUsSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllContactUsSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addContactUsSectionWithApproval } = useSelector(
        (state) => state?.addContactUsSectionWithApproval
    );




    const { updateContactUsSectionForReApproval } = useSelector(
        (state) => state?.updateContactUsSectionForReApproval
    );

    const { approveContactUsSection } = useSelector((state) => state?.approveContactUsSection);
    const { rejectContactUsSection } = useSelector((state) => state?.rejectContactUsSection);



    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "getInTouch" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllContactUsSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLCONTACTUSSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "getInTouch" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllContactUsSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)


            }
        }


        fetchData();
    }, [addContactUsSection, approveContactUsSection, rejectContactUsSection, addContactUsSectionWithApproval, deleteContactUsSection, updateContactUsSection, updateContactUsSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllContactUsSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllContactUsSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllContactUsSectionsBySectionNameBasedOnCreator, getAllContactUsSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")


    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteContactUsSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETECONTACTUSSECTION(data1));
        if (responseData?.payload?.message === "Contact Us section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }


    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>

                <CustomTable
                    // tableEdit="tableEdit"
                    // tableDelete="tableDelete"

                    tableData={rowTableData} title="Banner" tableHeadData={tableHeadData}
                    //   modalName={BannerinputGetModal}
                    //   editModalName={BannerinputGetModal}


                    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
                    tableView={true}
                    modalVeiwName={PreviewComponent}
                    ModalPreviewComponent1={ContactUsection}
                    sectionNameForApproveAndReject="ContactUsSecttion"


                    handleTableDataDelete={handleTableDataDelete}


                    tableDelete={permissions?.ContentManagement?.Blog?.delete}
                    tableEdit={permissions?.ContentManagement?.Blog?.edit}
                    dataCreate={permissions?.ContentManagement?.Blog?.add}
                    //   apiBasedName="stakeNowBannerInputModal"
                    //   tableData={rowTableData}
                    //   title="Banner"
                    //   tableHeadData={tableHeadData}
                    modalName={ContactUsModal}
                    editModalName={ContactUsModal}
                //   handleTableDataDelete={handleTableDataDelete}

                />

            </Grid>
        </Grid>
    )
}

export default ContactUsSection